module.exports = __webpack_public_path__ + "static/media/whiteLogo.22f7e14e.png";